// Pure helpers for `[[path]]`-style autocomplete in plain textareas.
// Extracted from hooks/index.ts so they are reachable from tests without
// importing the full hook bundle (which pulls in `.dox/ts/unions`).

// Pure: detect if the text before the cursor contains an active [[ trigger.
// Returns the query string after the `[[` if open, else null.
export const matchAutocompleteTrigger = (
  textBeforeCursor: string,
): string | null => {
  const m = textBeforeCursor.match(/\[\[([^\]]*?)$/);
  return m ? m[1]! : null;
};

// Pure: splice a completed file reference into text at the [[ trigger position.
// Returns the new value and where the cursor should end up (just after the
// closing `]]`). Returns null when no `[[` precedes the cursor.
export const spliceAutocomplete = (
  text: string,
  cursorPos: number,
  file: string,
): { value: string; cursor: number } | null => {
  const before = text.substring(0, cursorPos);
  const after = text.substring(cursorPos);
  const bracketIdx = before.lastIndexOf("[[");
  if (bracketIdx < 0) return null;
  const value = before.substring(0, bracketIdx) + "[[" + file + "]]" + after;
  const cursor = bracketIdx + file.length + 4;
  return { value, cursor };
};
